import * as API from '@api/interfaces';
import { AsyncState, createNamedContext } from '@utils';
import { VideoAdditionalDetailsContextValue } from './interfaces';

export const TopicsNavigationContext = createNamedContext<AsyncState<API.Discovery.FetchVideoTopics.Response> | undefined>(undefined, 'TopicsNavigation.Context');

export const VideoAdditionalDetailsContext = createNamedContext<VideoAdditionalDetailsContextValue | undefined>(undefined, 'Video.AdditionalDetails.Context');